import styled, { css } from "styled-components";

const baseStyles = css`
  margin: 0;
  letter-spacing: 0.1px;
`;

const defaultHeaderHue = css`
  color: ${({ theme }) => theme.colors.redesign.db100};
`;

const defaultTextHue = css`
  color: ${({ theme }) => theme.colors.redesign.db80};
`;

export const Body = styled.p`
  ${baseStyles}
  ${defaultTextHue}
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
`;

export const BodyLong = styled.p`
  ${baseStyles}
  ${defaultTextHue}
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
`;

export const BodySmall = styled.p`
  ${baseStyles}
  ${defaultTextHue}
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
`;

export const BodySmallBold = styled.p`
  ${baseStyles}
  ${defaultTextHue}
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
`;

export const Caption = styled.div`
  ${baseStyles}
  ${defaultTextHue}
    font-size: 12px;
  line-height: 16px;
  font-weight: 400;
`;

export const H3 = styled.h3`
  ${baseStyles}
  ${defaultHeaderHue}
  font-size: 22px;
  line-height: 32px;
  font-weight: 600;
`;

export const H4 = styled.h4`
  ${baseStyles}
  ${defaultHeaderHue}
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
`;

export const Overline3 = styled.div`
  ${baseStyles}
  ${defaultTextHue}
  font-size: 10px;
  line-height: 16px;
  font-weight: 800;
  text-transform: uppercase;
`;

export const Title = styled.div`
  text-align: center;
  margin-bottom: 12px;
`;

export const InstructionCard = styled.div`
  padding: 16px;
  background-color: rgb(252, 243, 237)};
`;

export const Divider = styled.div`
  height: 1px;
  margin: 12px 0;
  background-color: ${({ theme }) => theme.colors.redesign.o20};
`;

export const AboutContainer = styled.div`
  margin: 24px;
`;

export const StyledH4 = styled(H4)`
  padding-bottom: 8px;
`;

export const StyledBody = styled(Body)`
  white-space: pre-wrap;
`;
